// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Container----Container-module---container---3KHiT","text":"src-components-Container----Container-module---text---2-KQ0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/Container.module.scss
// module id = 71
// module chunks = 29990747609436 58411574672382 144251824217401